import React, {useState } from 'react'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import {addRoleApi ,updateRoleApi} from "../apiService";
import { checkApiStatus } from '../../../../utils';
import { useSnackbar } from 'notistack';
import { trackActivity } from '../../../../utils/mixpanel';
import { regexConstants } from '../../../../constants/regEx';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';


const PartyRoleCRU = ({ roleCRU, modeType, getResponseBack, onToggleModal, params }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [role, setRole] = useState(roleCRU?.data);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const onAddEditPartiesRole = () => {
        let validationInputs = {};
        validationInputs = {
            name: role?.name?.trim() ? "" : "Please enter Role",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (role.id) {
                globalPutService(updateRoleApi({ asset_slug: role?.slug }), role)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Party Role`, success_msg: response?.data?.message, item_id: role?.id, payload: role, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Party Role`, error_msg: response?.data?.message, item_id: role?.id, payload: role, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addRoleApi({ leaseSlug: params?.leaseSlug, }), role).then((response) => {
                    if (checkApiStatus(response)) {
                        setLoading(false);
                        onToggleModal();
                        getResponseBack();
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Party Role`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: role, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Party Role`, error_msg: response?.data?.message, item_id: null, payload: role, response: response?.data })
                    }
                })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Party Role`, error_msg: validationInputs, })
        }
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Party Role`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                // onClose={(event, reason) => { if (reason !== 'backdropClick') { onToggleModal(); } }}
                aria-labelledby="customized-dialog-title"
                className="add-lease-dialog"
                maxWidth="md"
                open={true}
                fullWidth
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === "add" ? "Add Role" : modeType === "edit" ? "Edit Role" : "View Role"}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                disabled={modeType === "view"}
                                id="name"
                                label="Role"
                                variant="outlined"
                                size="small"
                                required
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={role?.name || ""}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (regexConstants.restrictUnicodeCharacters.test(val.trimStart()) || val === "") {
                                        if (val.length <= 50) {
                                            setRole((prev) => ({ ...prev, name: val }));
                                            setError((prev) => ({ ...prev, name: "" }));
                                        }
                                    } else {
                                        e.preventDefault();
                                    }
                                }}
                                onPaste={(e) => { const pasted = e.clipboardData.getData("text"); if (pasted.length > 50) { e.preventDefault(); } }}
                                error={Boolean(error.name)}
                                helperText={error.name || (role?.name?.length > 50 ? "Maximum 50 characters allowed" : "")}
                                fullWidth
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={role?.remarks || ""} />
                        </Grid> :
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                disabled={modeType === "view"}
                                id="remarks"
                                label="Remarks"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true } }}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                value={role?.remarks || ""}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    regexConstants.restrictUnicodeCharacters.test(val) || val === "" ? (() => { setRole((prev) => ({ ...prev, remarks: val.trimStart() })); setError((prev) => ({ ...prev, remarks: "" })); })() : e.preventDefault();
                                }}
                                error={!!error.remarks}
                                helperText={error.remarks}
                                fullWidth
                                multiline
                                rows={3}
                            />
                        </Grid>}
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant="contained" size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditPartiesRole() }} >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                        </Button>}

                </DialogActions>
            </Dialog>
        </>
    )
}

export default PartyRoleCRU